import Vue from 'vue'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'

Vue.use(VueMomentJS, moment)

let formatLongDatetime = function (value) {
  Vue.moment.locale(window.navigator.language)
  return Vue.moment.unix(value).format('llll')
  // const date = Vue.moment.unix(value).format('L')
  // const time = Vue.moment.unix(value).format('LT')
  // return `${date} at ${time}` // Vue.$i18n.t('{date} at {time}')
}

export default formatLongDatetime
